import jwtDecode from 'jwt-decode'
import Cookies from 'universal-cookie'
import { v4 as uuidv4 } from 'uuid'

import { JWTDataDTO } from '../api/user/User.dto'
import { ACCESS_TOKEN, DEVICE_ID, FCM_TOKEN, REFRESH_TOKEN, VIEWER_ID } from './consts'

const cookies = new Cookies()

const karnamehUrl = import.meta.env.VITE_KARNAMEH_URL

const cookieDomain =
  import.meta.env.MODE === 'production'
    ? 'app.karnameh.com'
    : karnamehUrl
    ? karnamehUrl.replace('https://', '')
    : 'localhost'

export const getFcmTokenFromCookie = () => {
  return cookies.get(FCM_TOKEN)
}

export const setFcmTokenCookie = (fcmToken: string) => {
  const expires = new Date()
  expires.setMonth(expires.getMonth() + 1)
  cookies.set(FCM_TOKEN, fcmToken, { expires, path: '/' })
}

export const getAccessTokenFromCookie = () => {
  return cookies.get(ACCESS_TOKEN)
}

export const getRefreshTokenFromCookie = () => {
  return cookies.get(REFRESH_TOKEN)
}

export const setAccessTokenCookie = (accessToken: string) => {
  const jwtToken = jwtDecode<JWTDataDTO>(accessToken)
  const expires = new Date(jwtToken.exp * 1000)
  cookies.set(ACCESS_TOKEN, accessToken, {
    expires,
    path: '/',
    secure: true,
    sameSite: 'strict',
    domain: cookieDomain,
  })
}

export const setRefreshTokenCookie = (token: string) => {
  const jwtToken = jwtDecode<JWTDataDTO>(token)
  const expires = new Date(jwtToken.exp * 1000)
  cookies.set(REFRESH_TOKEN, token, {
    expires,
    path: '/',
    secure: true,
    sameSite: 'strict',
    domain: cookieDomain,
  })
}

export const getDeviceIdFromCookie = () => {
  return cookies.get(DEVICE_ID)
}

export const setDeviceIdCookie = (deviceId: string) => {
  const expires = new Date()
  expires.setMonth(expires.getMonth() + 1)
  cookies.set(DEVICE_ID, deviceId, { expires, path: '/' })
}

export const setViewerIdCookie = () => {
  const expires = new Date()
  expires.setMonth(expires.getMonth() + 1)
  if (!cookies.get(VIEWER_ID)) {
    cookies.set(VIEWER_ID, uuidv4(), {
      expires,
      path: '/',
      domain: cookieDomain,
    })
  }
}

export const getViewerId = () => {
  return cookies.get(VIEWER_ID) ?? undefined
}
export const getCookieByKey = (key: string) => {
  return cookies.get(key)
}

export const setCookieByKey = (key: string, value: string) => {
  const expires = new Date()
  expires.setDate(expires.getDate() + 1)
  cookies.set(key, value, { expires, path: '/' })
}

export const removeCookie = (key: string) => {
  cookies.remove(key, { domain: cookieDomain, path: '/' })
}

export const clearCredentialCookies = () => {
  cookies.remove(FCM_TOKEN)
  cookies.remove(ACCESS_TOKEN, { domain: cookieDomain, path: '/' })
  cookies.remove(DEVICE_ID)
}
